import React, { useEffect, useRef } from "react";
import "./TinyHistogram.css";

interface Props {
  histogramData: Array<number>;
}

function TinyHistogram(props: Props) {
  // TODO: use sample rate to set axis.  also, chop off irrelevant freqs?
  const { histogramData } = props;

  const canvasRef = useRef<HTMLCanvasElement>(null);

  // const [mainFreqIndex, setMainFreqIndex] = useState(0);

  const AXIS_TEXT_HEIGHT = 0; // No text for now 14;

  useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas) {
      const context = canvas.getContext("2d");
      if (context) {
        canvas.width = 200;
        canvas.height = 100;
        if (histogramData?.length) {
          context.fillStyle = "#FFFFFF";
          context.fillRect(0, 0, context.canvas.width, context.canvas.height);
          context.fillStyle = "#444444";
          context.font = "normal normal 14px Helvetica";
          context.textBaseline = "top"; // how to align the text vertically
          // context.textAlign = "end"; // how to align the text horizontally
          // context.fillText(`${maxFreqConsidered.toFixed(0)}Hz`, context.canvas.width - 50, context.canvas.height - AXIS_TEXT_HEIGHT);
          // context.fillText(`${minFreqConsidered.toFixed(0)}Hz`, 0, context.canvas.height - AXIS_TEXT_HEIGHT);

          // yuck but I want to see it
          // let maxVal = 0;
          // let indexOfMaxVal = 0;
          // histogramData.forEach((val, index) => {
          //   if (val > maxVal) {
          //     maxVal = val;
          //     indexOfMaxVal = index;
          //   }
          // });
          // setMainFreqIndex(indexOfMaxVal);

          // The right side of the 4096 is pretty useless to look at
          const bars = Math.min(3000, histogramData.length);

          context.fillStyle = "#000000";
          for (let i = 0; i < bars; i++) {
            const barWidth = canvas.width / bars;
            const barHeight = histogramData[i] * 50; // FIXME: if hist properly normalized -1 to 1, could *100;
            context.fillRect(i * barWidth, canvas.height - barHeight - AXIS_TEXT_HEIGHT, barWidth, barHeight);
          }
        } else {
          context.fillStyle = "#FFFFFF";
          context.fillRect(0, 0, context.canvas.width, context.canvas.height);
        }
      }
    }
  }, [histogramData]);

  return (
    <div className="tiny-histogram-canvas-wrapper">
      <canvas className="tiny-histogam-canvas" ref={canvasRef} id="histogram"></canvas>
    </div>
  );
}

export default TinyHistogram;
